module.exports = __webpack_public_path__ + "img/metaplace_gnometown.98ca35fa.jpg";